import axiosClient from "../axios/axiosClient";

export function getStudentStatistics() {
  return axiosClient.get("/student-statistics");
}

export function getStudentStatistic(studentStatisticsId) {
  return axiosClient.get(`/student-statistics/${studentStatisticsId}`);
}

export function createStudentStatistics(data) {
  return axiosClient.post("/student-statistics", data);
}

export const updateStudentStatistics = (studentStatisticsId, data) => {
  return axiosClient.put(`/student-statistics/${studentStatisticsId}`, data);
};

export function deleteStudentStatistics(studentStatisticsId) {
  return axiosClient.delete(`/student-statistics/${studentStatisticsId}`);
}

export const batchUpdateStudentStatistics = (data) => {
  return axiosClient.put("/student-statistic/batch-update", data);
};
